/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/

import { animate, state, style, transition, trigger } from '@angular/animations';

export class AppConstants {
  public static MAPS_API_KEY = 'AIzaSyCiNBT6rUZvmx1Zw4DX_G3O_3FLtw11UXI';
  public static STRIPE_PUBLISHABLE_KEY__PROD = 'pk_live_BvENGbLx0kEZaIomgnldsYCs';
  public static STRIPE_PUBLISHABLE_KEY__DEV = 'pk_test_MuqJzgnKbHd5ApVWy0HITQFY';
}

export enum FINANCIAL_TYPE {
  // FREIGHT_REVENUE = 'Freight Revenue',
  FREIGHT_REVENUE_INCREASED = 'Increased Freight Revenue',
  FREIGHT_REVENUE_DISCOUNTED = 'Discounted Freight Revenue',
  // FLAT_RATE = 'Flat Rate',
  FLAT_RATE_INCREASED = 'Increased Flat Rate',
  FLAT_RATE_DECREASED = 'Decreased Flat Rate',
  LUMPER = 'Lumper',
  ADVANCED_LUMPER = 'Advance Lumper',
  ADVANCED_LUMPER_AR = 'Advance Lumper AR',
  DEADHEAD = 'Deadhead',
  DETENTION = 'Detention',
  FUEL = 'Fuel',
  EXTRA_STOPS = 'Extra Stops',
  MILEAGE = 'Mileage',
  TOLL = 'Toll',
  TONU = 'Truck Order Not Used (TONU)',
  LAYOVER = 'Layover',
  TRACKING_INCENTIVES = 'Tracking Incentives',
  ONTIMEDELIVERY = 'On Time Pick-up/Delivery Incentive',
  HOURLY_RATE = 'Hourly Rate For Shuttle Project',
}

export enum CREATED_ON_PLATFORM {
  BROKER = 'broker',
  SHIPPER = 'shipper',
  EXTERNAL = 'external',
}

export enum DEFAULT_FEE {
  INITIAL_FREIGHT_REVENUE = 'Initial Freight Revenue',
  INITIAL_FLAT_RATE = 'Initial Flat Rate',
}

export enum PAYMENT_METHODS {
  STANDARD = 'Standard Pay',
  QUICK = 'Quick Pay',
}

export enum PAYMENT_TERMS {
  BILL = 30,
  INVOICE = 30,
}

export enum EDI_CUSTOMERS {
  HOME_DEPOT = 'Home Depot',
}

// In the "Log EDI Check Call" you can select "EDI Reason Code" or "EDI Status Code", not both.
export const EDI_CUSTOMER_SINGLE_CODE: EDI_CUSTOMERS[] = [EDI_CUSTOMERS.HOME_DEPOT];

export enum EDI_CUSTOMERS_STATUS_CODES {
  AA = 'Pick-up Appointment Date and/or Time',
  AB = 'Delivery Appointment Date and/or Time',
}

export const DEFAULT_PING_TIME = {
  name: '15 Min (default)',
  value: 15,
};

export enum SNACKBAR_NOTIFICATION_TYPE {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export const MAX_FLOOR_HEIGHT = 108; // inch
export const MAX_FLOOR_LENGTH = 53; // feet

export const INVITE_MESSAGE = 'You are invited to join Zuum Platform here:';

export enum FORM_PATTERNS {
  PHONE_NUMBER = '(\\+1 )?\\(\\d{3}\\) \\d{3}-\\d{4}',
  PHONE_NUMBER_EXT = '^[0-9]*$',
  EMAIL = '[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,7}',
  PASSWORD = '^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\\d]){1,})(?=(.*[\\W]){1,})(?!.*\\s).{6,30}$',
  URL = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?',
}

export enum PASSWORD_PATTERNS {
  LOWER_CASE = '(.*[a-z].*)',
  UPPER_CASE = '(.*[A-Z].*)',
  DIGITS = '(.*\\d.*)',
  SPECIALS = '[ `!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?~]',
}

export enum DATE_INTERVALS {
  CUSTOM = 'Custom',
  CURRENT_DAY = 'Current Day',
  PREVIOUS_DAY = 'Previous Day',
  LAST_7_DAYS = 'Last 7 Days',
  LAST_30_DAYS = 'Last 30 Days',
  LAST_90_DAYS = 'Last 90 Days',
  LAST_180_DAYS = 'Last 180 Days',
  LAST_365_DAYS = 'Last 365 Days',
  MONTH_TO_DATE = 'Month To Date',
  CURRENT_MONTH = 'Current Month',
  CURRENT_WEEK = 'Current Week',
  PREVIOUS_WEEK = 'Previous Week',
  QUARTER_TO_DATE = 'Quarter To Date',
  YEAR_TO_DATE = 'Year To Date',
}

export const COMPANY_NUMBER_OF_EMPLOYEES = [
  '0 - 50',
  '51 - 100',
  '101 - 150',
  '151 - 200',
  '201 - 250',
  '251 - 300',
  '300+',
];
export const COMPANY_AVG_ANUAL_FREIGHT_SPEND = [
  'under 500k',
  '500k - 1M',
  '1 - 2 M',
  '2 - 4 M',
  '4 - 10 M',
  '10 - 50 M',
  '50 - 100 M',
  '100 - 500 M',
  '500M - 1B',
  '1B +',
];
export const COMPANY_SHIPMENTS_PER_WEEK = [
  '0 - 50',
  '51 - 100',
  '101 - 150',
  '151 - 200',
  '201 - 250',
  '251 - 300',
  '300+',
];

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const APPLY_FOR_CREDIT_TOOLTIP = `Broker 'Accounting - Credit Application' feature must be enabled`;

export const EXPANDIBLE_TABLE_ANMATIONS = [
  trigger('detailExpand', [
    state('collapsed', style({ height: '0px', minHeight: '0' })),
    state('expanded', style({ height: '*' })),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
];
export enum PILL_COLOR_PALETTE {
  BLACK = 'black',
  GRAY = 'gray',
  GREEN = 'green',
  RED = 'red',
}

export type AVAILABLE_PILL_COLORS = `${PILL_COLOR_PALETTE}`;
